<template>
    <div id="row" class="d-flex flex-column align-items-left">
      <div class="row1 d-flex flex-rows justify-content-between align-items-center">
        <div class="lg1">
          <div class="title">{{title.lg1}}</div>
          <div class="subtitle">{{subtitle.lg1}}</div>
        </div>
        <div class="price float-right">{{price}}</div>
      </div>
    </div>
</template>

<script>
export default {
  name: 'IbisRatesHorizontalV1ServicesRow',
  props: {
    servicesLg1: Object,
    servicesLg2: Object
  },
  computed: {
    title () {
      return {lg1: this.servicesLg1.label_value, lg2: this.servicesLg2 && this.servicesLg2.label_value}
    },
    subtitle () {
      return {lg1: this.servicesLg1.sub_label, lg2: this.servicesLg2 && this.servicesLg2.sub_label}
    },
    price () {
      return this.servicesLg1.msr_value
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_ibis.scss";

#row {
  width: 100%;
  @include heightPercent(149);
  border-top: 1px solid $border;

  .row1 {
    margin-top: 3vh;
    .lg1 {
      max-height: 120 * 100vh / $srcHeight;
      overflow: hidden;

      .title {
        font-family: "Helvetica-Roman";
        @include fontSize(42);
        max-height: 52 * 100vh / $srcHeight;
        max-width: 652 * 160vh / $srcWidth;
        overflow: hidden;
      }

      .subtitle {
        font-family: "Helvetica-Oblique";
        @include fontSize(26);
        max-height: 32 * 100vh / $srcHeight;
        max-width: 812 * 160vh / $srcWidth;
        padding-right: 5px;
        overflow: hidden;
      }
    }

    .price {
      font-family: "Helvetica-Bold";
      @include fontSize(45);
      color: $grey;
      white-space: nowrap;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ibis/rates/horizontal/v1/services/rowServices.vue